/**
 * Localización en Español para FaceTec Browser SDK
 *
 * Este archivo contiene todas las traducciones al español
 * para los textos de la interfaz de FaceTec.
 */
export var FACETEC_SPANISH_STRINGS = {
    // Botones de Acción
    "FaceTec_action_im_ready": "Estoy Listo",
    "FaceTec_action_try_again": "Intentar Nuevamente",
    "FaceTec_action_continue": "Continuar",
    "FaceTec_action_take_photo": "Tomar Foto",
    "FaceTec_action_accept_photo": "Aceptar",
    "FaceTec_action_retake_photo": "Volver a Tomar",
    "FaceTec_action_confirm": "Confirmar",
    "FaceTec_action_ok": "OK",
    // Accesibilidad
    "FaceTec_accessibility_cancel_button": "Cancelar",
    "FaceTec_accessibility_tap_guidance": "Toque dos veces para obtener ayuda",
    "FaceTec_accessibility_key_down_guidance": "Presione la tecla de flecha hacia abajo para obtener ayuda",
    // Mensajes de Retroalimentación Durante el Escaneo Facial
    "FaceTec_feedback_center_face": "Centre su Rostro",
    "FaceTec_feedback_face_not_found": "Encuadre su Rostro",
    "FaceTec_feedback_move_phone_away": "Aléjese",
    "FaceTec_feedback_move_away_web": "Aléjese",
    "FaceTec_feedback_move_phone_closer": "Acérquese",
    "FaceTec_feedback_move_web_closer": "Acérquese a la Cámara",
    "FaceTec_feedback_move_web_even_closer": "Aún Más Cerca",
    "FaceTec_feedback_move_phone_to_eye_level": "Suba el Teléfono a la Altura de los Ojos",
    "FaceTec_feedback_move_to_eye_level_web": "Mire Directamente a la Cámara",
    "FaceTec_feedback_use_even_lighting": "Iluminación Más Uniforme",
    "FaceTec_feedback_frame_your_face": "Encuadre su Rostro",
    "FaceTec_feedback_hold_steady": "Manténgase Quieto",
    "FaceTec_feedback_move_phone_even_closer": "Más Cerca",
    "FaceTec_feedback_face_not_looking_straight_ahead": "Mire al Frente",
    "FaceTec_feedback_face_not_upright": "Mantenga la Cabeza Derecha",
    "FaceTec_feedback_face_not_upright_mobile": "Mantenga la Cabeza Derecha",
    "FaceTec_feedback_hold_steady1s": "Manténgase Quieto: 1s",
    "FaceTec_feedback_hold_steady2s": "Manténgase Quieto: 2s",
    "FaceTec_feedback_hold_steady3s": "Manténgase Quieto: 3s",
    "FaceTec_feedback_eyes_straight_ahead": "Mire al Frente",
    "FaceTec_feedback_remove_dark_glasses": "Quítese los Lentes Oscuros",
    "FaceTec_feedback_neutral_expression": "Expresión Neutral, Sin Sonreír",
    "FaceTec_feedback_conditions_too_bright": "Demasiada Luz",
    "FaceTec_feedback_brighten_your_environment": "Iluminación Demasiado Baja",
    // Pantalla de Preparación (Ready Screen)
    "FaceTec_presession_frame_your_face": "Encuadre su Rostro en el Óvalo",
    "FaceTec_presession_look_straight_ahead": "Mire Directamente al Frente",
    "FaceTec_presession_hold_steady3": "Manténgase Quieto por 3 Segundos",
    "FaceTec_presession_position_face_straight_in_oval": "Posicione su Rostro en el Óvalo",
    "FaceTec_presession_eyes_straight_ahead": "Mire al Frente",
    "FaceTec_presession_remove_dark_glasses": "Quítese los Lentes Oscuros",
    "FaceTec_presession_neutral_expression": "Expresión Neutral, Sin Sonreír",
    "FaceTec_presession_conditions_too_bright": "Ambiente Demasiado Brillante",
    "FaceTec_presession_brighten_your_environment": "Ambiente Demasiado Oscuro",
    // Instrucciones de inicio (Pantalla Ready)
    // "FaceTec_instructions_header_ready": "Prepárese para su verificación",
    "FaceTec_instructions_header_ready_desktop": "Prepárese para su verificación",
    "FaceTec_instructions_header_ready_1_mobile": "Prepárese para su verificación",
    "FaceTec_instructions_header_ready_2_mobile": "",
    "FaceTec_instructions_header_ready_1": "Prepárese para su verificación",
    "FaceTec_instructions_header_ready_2": "",
    // "FaceTec_instructions_message_ready": "Encuadre su rostro en el óvalo, Presione Estoy Listo y Acérquese",
    "FaceTec_instructions_message_ready_1": "Encuadre su rostro en el óvalo, Presione Estoy Listo y Acérquese",
    "FaceTec_instructions_message_ready_2": "",
    "FaceTec_instructions_message_ready_desktop": "Encuadre su rostro en el óvalo, Presione Estoy Listo y Acérquese",
    "FaceTec_instructions_message_ready_1_mobile": "Encuadre su rostro en el óvalo, Presione Estoy Listo y Acérquese",
    "FaceTec_instructions_message_ready_2_mobile": "",
    // Mensajes de Resultado
    "FaceTec_result_facescan_upload_message": "Subiendo<br/>Escaneo Facial Encriptado",
    "FaceTec_result_idscan_upload_message": "Subiendo<br/>Documento Encriptado",
    "FaceTec_result_success_message": "Éxito",
    "FaceTec_result_uploading_message": "Subiendo<br/>Información Encriptada",
    "FaceTec_result_success_message_header": "Rostro Escaneado",
    "FaceTec_result_facescan_success_message": "Rostro Escaneado",
    "FaceTec_result_liveness_proven_message": "Verificación 3D Completada",
    // Escaneo de Documento de Identidad
    "FaceTec_idscan_type_selection_header": "Capture su<br/>Documento de Identidad",
    "FaceTec_idscan_capture_id_front_instruction_message": "Muestre el Frente de su Documento",
    "FaceTec_idscan_capture_id_back_instruction_message": "Muestre el Reverso de su Documento",
    "FaceTec_idscan_review_id_front_instruction_message": "Confirme que la Foto es Clara y Legible",
    "FaceTec_idscan_review_id_back_instruction_message": "Confirme que la Foto es Clara y Legible",
    "FaceTec_idscan_additional_review_message": "Revisión Adicional<br/>Necesaria",
    "FaceTec_idscan_ocr_confirmation_main_header": "Revise y Confirme",
    "FaceTec_idscan_ocr_confirmation_scroll_message": "Desplácese para Ver Todos los Campos",
    // Tipos de Documento
    "FaceTec_idscan_type_id_card": "Cédula de Identidad",
    "FaceTec_idscan_type_passport": "Pasaporte",
    "FaceTec_idscan_type_drivers_license": "Licencia de Conducir",
    // Pantalla de Reintento
    "FaceTec_retry_header": "Intentemos de nuevo",
    "FaceTec_retry_subheader_message": "Necesitamos una Foto Más Clara",
    "FaceTec_retry_your_image_label": "Su Selfie",
    "FaceTec_retry_ideal_image_label": "Pose Ideal",
    "FaceTec_retry_instruction_message": "Por favor use pose e iluminación ideal",
    "FaceTec_retry_instruction_message_1": "Sostener Cámara a la Altura de los Ojos",
    "FaceTec_retry_instruction_message_2": "Ilumine su Rostro Uniformemente",
    "FaceTec_retry_instruction_message_3": "Evite Sonreír y Contraluz",
    "FaceTec_retry_your_image_did_not_meet_standards": "Su Imagen No Cumplió con los Estándares",
    "FaceTec_retry_face_not_fully_visible": "Rostro No Completamente Visible",
    "FaceTec_retry_lighting_too_low": "Iluminación Demasiado Baja",
    "FaceTec_retry_lighting_too_extreme": "Iluminación Demasiado Extrema",
    "FaceTec_retry_id_not_fully_visible": "Documento No Completamente Visible",
    "FaceTec_retry_id_not_horizontal": "Documento No Horizontal",
    "FaceTec_retry_id_type_not_supported": "Tipo de Documento No Soportado",
    "FaceTec_retry_id_glare_detected": "Reflejo Detectado en el Documento",
    "FaceTec_retry_id_barcode_not_read": "Código de Barras No Leído",
    "FaceTec_retry_official_id_photo_header": "Intentémoslo otra vez",
    "FaceTec_retry_official_id_photo_subheader_message": "La foto debe tener más calidad",
    "FaceTec_retry_official_id_photo_instruction_message": "Use luz interior,<br/>sin sonreír, lentes con reflejos o sombreros",
    "FaceTec_retry_official_id_photo_your_image_label": "Su imagen",
    "FaceTec_retry_official_id_photo_ideal_image_label": "Cara conforme",
    // Mensajes de Cancelación
    "FaceTec_camera_feed_issue_header": "Problema con la Cámara",
    "FaceTec_camera_feed_issue_subheader_message": "No se Puede Conectar a la Cámara",
    "FaceTec_camera_feed_issue_advice": "Verifique los Permisos de la Cámara",
    "FaceTec_camera_feed_issue_table_header": "Posibles Causas:",
    "FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error": "Permisos de Cámara no Otorgados en Firefox.",
    "FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error": "Haga clic en el ícono de cámara tachado en la barra de direcciones y seleccione \"No Bloquear\".",
    "FaceTec_camera_feed_issue_table_row_1_cell_1": "La cámara ya está en uso.",
    "FaceTec_camera_feed_issue_table_row_1_cell_2": "Cierre otras aplicaciones que usan la cámara.",
    "FaceTec_camera_feed_issue_table_row_2_cell_1": "Una extensión del navegador está bloqueando el acceso a la cámara.",
    "FaceTec_camera_feed_issue_table_row_2_cell_2": "Deshabilite extensiones de privacidad o cambios a la configuración del navegador.",
    "FaceTec_camera_feed_issue_table_row_3_cell_1": "La cámara no está disponible o no es compatible con este navegador.",
    "FaceTec_camera_feed_issue_table_row_3_cell_2": "Intente usar una cámara diferente o actualice su navegador.",
    "FaceTec_camera_feed_issue_subtable_message": "Este sitio requiere acceso a la cámara para capturar imágenes de verificación biométrica.",
    // Inicialización
    "FaceTec_init_camera_permissions_header": "Habilitar Cámara",
    "FaceTec_init_camera_permissions_message": "Se Requieren Permisos de Cámara",
    "FaceTec_init_message": "Inicializando...",
    // Pantalla de Inicialización y Progreso
    "FaceTec_initializing_camera": "Asegurando la Cámara...",
    "FaceTec_result_facescan_upload_message_still_uploading": "Subiendo...<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_still_uploading": "Subiendo...<br/>Conexión Lenta",
    "FaceTec_result_nfc_upload_message": "Subiendo<br/>Datos NFC Encriptados",
    "FaceTec_result_nfc_upload_message_still_uploading": "Subiendo...<br/>Conexión Lenta",
    "FaceTec_result_facescan_success_3d_enrollment_message": "Registro 3D<br/>Completado",
    "FaceTec_result_facescan_success_3d_3d_reverification_message": "Verificación 3D<br/>Exitosa",
    "FaceTec_result_facescan_success_3d_liveness_prior_to_idscan_message": "Verificación de Rostro<br/>Completada",
    "FaceTec_result_facescan_success_3d_liveness_and_official_id_photo_message": "Verificación<br/>Completada",
    // Pantalla de Permisos de Cámara
    "FaceTec_camera_permission_message": "Los permisos de cámara están deshabilitados.<br/>Por favor revise la configuración de su sistema y navegador.",
    "FaceTec_camera_permission_header": "Habilitar Cámara",
    "FaceTec_camera_permission_message_enroll": "Por favor toque el botón de abajo<br/>para habilitar su cámara selfie.",
    "FaceTec_camera_permission_message_auth": "Su cámara está deshabilitada.<br/>Toque abajo para editar la configuración.",
    "FaceTec_camera_permission_enable_camera": "HABILITAR CÁMARA",
    "FaceTec_camera_permission_launch_settings": "IR A CONFIGURACIÓN",
    // Mensajes de Pantalla Completa
    "FaceTec_enter_fullscreen_header": "Modo de Escaneo<br/>de Pantalla Completa",
    "FaceTec_enter_fullscreen_message": "Antes de comenzar, presione el botón a continuación para abrir el modo de pantalla completa.",
    "FaceTec_enter_fullscreen_action": "Abrir Pantalla Completa",
    // Otros
    "FaceTec_action_accept": "Aceptar",
    "FaceTec_accessibility_cancel": "Cancelar",
    "FaceTec_accessibility_feedback_move_phone_closer": "Acérquese al dispositivo",
    "FaceTec_accessibility_feedback_move_phone_away": "Aléjese del dispositivo",
    "FaceTec_accessibility_feedback_face_too_far_left": "Su rostro está demasiado a la izquierda",
    "FaceTec_accessibility_feedback_face_too_far_right": "Su rostro está demasiado a la derecha",
    "FaceTec_accessibility_feedback_face_too_low": "Su rostro está demasiado abajo",
    "FaceTec_accessibility_feedback_face_too_high": "Su rostro está demasiado arriba",
    "FaceTec_accessibility_feedback_face_rotated_too_far_left": "Su rostro gira demasiado a la izquierda",
    "FaceTec_accessibility_feedback_face_rotated_too_far_right": "Su rostro gira demasiado a la derecha",
    "FaceTec_accessibility_feedback_face_looking_too_far_left": "Su rostro está demasiado inclinado hacia la izquierda",
    "FaceTec_accessibility_feedback_face_looking_too_far_right": "Su rostro está demasiado inclinado hacia la derecha",
    "FaceTec_accessibility_feedback_face_not_in_camera": "El rostro no se ve en la cámara o está demasiado lejos",
    "FaceTec_accessibility_feedback_hold_phone_to_eye_level": "Mantenga el dispositivo a la altura de los ojos",
    "FaceTec_accessibility_feedback_move_away_web": "Cámara demasiado cerca",
    "FaceTec_accessibility_feedback_move_closer_web": "Cámara demasiado lejos",
    "FaceTec_accessibility_feedback_hold_to_eye_level_web": "Mover la cámara al nivel de los ojos",
    // Strings adicionales para pantalla de preparación
    "FaceTec_presession_position_face_straight_in_oval_accessibility": "Posicione su rostro recto en el óvalo",
    "FaceTec_presession_hold_steady_accessibility": "Manténgase quieto",
    // Mensajes de subida y procesamiento
    "FaceTec_result_facemap_upload_message": "Subiendo<br/>Mapa Facial 3D Encriptado",
    "FaceTec_result_idscan_success_front_side_message": "Frente del Documento Capturado",
    "FaceTec_result_idscan_success_front_side_back_next_message": "Frente Capturado<br/>Ahora Muestre el Reverso",
    "FaceTec_result_idscan_success_back_side_message": "Reverso del Documento Capturado",
    "FaceTec_result_idscan_success_passport_message": "Pasaporte Capturado",
    "FaceTec_result_idscan_success_user_confirmation_message": "Revisión Completada",
    "FaceTec_result_idscan_success_additional_review_message": "Escaneo de ID<br/>Completado",
    "FaceTec_result_idscan_unsuccess_message": "Escaneo de Documento<br/>No Completado",
    "FaceTec_result_idscan_retry_face_did_not_match_message": "El Rostro No Coincidió<br/>Por Favor Intente Nuevamente",
    "FaceTec_result_idscan_retry_id_not_fully_visible_message": "Documento No Completamente Visible",
    "FaceTec_result_idscan_retry_ocr_results_not_good_enough_message": "Texto No Legible<br/>Por Favor Intente Nuevamente",
    "FaceTec_result_idscan_retry_id_type_not_supported_message": "Tipo de Documento No Soportado<br/>Use Otro Documento",
    "FaceTec_result_idscan_retry_id_type_not_suppported_message": "Tipo de Documento No Soportado<br/>Use Otro Documento",
    "FaceTec_result_idscan_retry_barcode_not_read_message": "Código de Barras No Leído<br/>Por Favor Intente Nuevamente",
    // Mensajes de sesión
    "FaceTec_session_cancelled_by_user": "Sesión Cancelada por el Usuario",
    "FaceTec_session_unsuccessful": "Sesión No Completada",
    "FaceTec_session_timeout": "Tiempo de Sesión Agotado",
    "FaceTec_session_camera_permission_denied": "Permiso de Cámara Denegado",
    // Verificación de vivacidad
    "FaceTec_liveness_checking": "Verificando Vivacidad...",
    "FaceTec_liveness_retry_message": "Verificación No Exitosa<br/>Por Favor Intente Nuevamente",
    // Coincidencia facial
    "FaceTec_match_checking": "Verificando Coincidencia...",
    "FaceTec_match_3d_2d_message": "Comparando con Foto de Documento",
    "FaceTec_match_success_message": "Coincidencia Verificada",
    "FaceTec_match_unsuccess_message": "Coincidencia No Verificada",
    // NFC (si aplica)
    "FaceTec_nfc_scan_header": "Escaneo NFC",
    "FaceTec_nfc_scan_message": "Acerque su Documento al Dispositivo",
    "FaceTec_nfc_scan_success_message": "Chip NFC Leído Exitosamente",
    "FaceTec_nfc_scan_retry_message": "No se Pudo Leer el Chip<br/>Intente Nuevamente",
    // ===== MENSAJES DE UPLOAD DE ID SCAN (ID & NFC Scan Upload Screen) =====
    // Frente del documento
    "FaceTec_result_idscan_upload_message_front_side_upload_started": "Subiendo<br/>Frente del Documento Encriptado",
    "FaceTec_result_idscan_upload_message_front_side_still_uploading": "Aún Subiendo<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_front_side_upload_complete_awaiting_response": "Carga Completa",
    "FaceTec_result_idscan_upload_message_front_side_upload_complete_awaiting_processing": "Procesando<br/>Frente del Documento",
    // Reverso del documento
    "FaceTec_result_idscan_upload_message_back_side_upload_started": "Subiendo<br/>Reverso del Documento Encriptado",
    "FaceTec_result_idscan_upload_message_back_side_still_uploading": "Aún Subiendo<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_back_side_upload_complete_awaiting_response": "Carga Completa",
    "FaceTec_result_idscan_upload_message_back_side_upload_complete_awaiting_processing": "Procesando<br/>Reverso del Documento",
    // Confirmación de información del usuario
    "FaceTec_result_idscan_upload_message_user_confirmed_info_upload_started": "Subiendo<br/>Información Confirmada",
    "FaceTec_result_idscan_upload_message_user_confirmed_info_still_uploading": "Aún Subiendo<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_user_confirmed_info_upload_complete_awaiting_response": "Carga Completa",
    "FaceTec_result_idscan_upload_message_user_confirmed_info_upload_complete_awaiting_processing": "Procesando<br/>Información Confirmada",
    // NFC Upload
    "FaceTec_result_idscan_upload_message_nfc_upload_started": "Subiendo<br/>Datos NFC Encriptados",
    "FaceTec_result_idscan_upload_message_nfc_still_uploading": "Aún Subiendo<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_nfc_upload_complete_awaiting_response": "Carga Completa",
    "FaceTec_result_idscan_upload_message_nfc_upload_complete_awaiting_processing": "Procesando<br/>Datos NFC",
    // NFC Omitido
    "FaceTec_result_idscan_upload_message_skipped_nfc_upload_started": "Subiendo<br/>Documento sin NFC",
    "FaceTec_result_idscan_upload_message_skipped_nfc_still_uploading": "Aún Subiendo<br/>Conexión Lenta",
    "FaceTec_result_idscan_upload_message_skipped_nfc_upload_complete_awaiting_response": "Carga Completa",
    "FaceTec_result_idscan_upload_message_skipped_nfc_upload_complete_awaiting_processing": "Procesando<br/>Documento",
    // ===== MENSAJES DE ÉXITO DE ID SCAN =====
    "FaceTec_result_idscan_success_nfc_message": "Escaneo NFC<br/>Completado",
    "FaceTec_result_idscan_success_passport_nfc_next_message": "Pasaporte Capturado<br/>Ahora Escanee el Chip NFC",
    "FaceTec_result_idscan_skip_or_error_nfc_message": "Escaneo NFC<br/>Omitido",
    // ===== MENSAJES DE PROCESAMIENTO DE ID SCAN =====
    "FaceTec_result_idscan_processing": "Procesando<br/>Escaneo de Documento",
    "FaceTec_result_idscan_complete": "Documento<br/>Escaneado",
    // ===== MENSAJES DE FLIP ID (Voltear documento) =====
    "FaceTec_idscan_feedback_flip_id_to_front_message": "Muestre el Frente<br/>de su Documento",
    "FaceTec_idscan_feedback_flip_id_to_back_message": "Muestre el Reverso<br/>de su Documento",
    // ===== MENSAJES DE NFC STATUS =====
    "FaceTec_idscan_nfc_status_starting_message": "Preparando<br/>Escaneo NFC...",
    "FaceTec_idscan_nfc_card_status_starting_message": "Preparando<br/>Lectura de Tarjeta...",
    "FaceTec_idscan_nfc_status_scanning_message": "Escaneando<br/>Chip NFC...",
    "FaceTec_idscan_nfc_status_weak_connection_message": "Conexión Débil<br/>Mantenga el Documento Cerca",
    "FaceTec_action_skip_nfc": "Omitir NFC",
    "FaceTec_idscan_nfc_status_disabled_message": "NFC No Disponible<br/>en este Dispositivo",
    "FaceTec_idscan_nfc_status_ready_message": "Listo para<br/>Escanear NFC",
    "FaceTec_idscan_nfc_card_status_ready_message": "Listo para<br/>Leer Tarjeta",
    "FaceTec_action_scan_nfc": "Escanear NFC",
    "FaceTec_action_scan_nfc_card": "Leer Tarjeta NFC",
    "FaceTec_idscan_nfc_status_skipped_message": "Escaneo NFC<br/>Omitido",
    "FaceTec_idscan_nfc_status_finished_with_error_message": "Error en<br/>Escaneo NFC",
    "FaceTec_idscan_nfc_card_status_finished_with_error_message": "Error al<br/>Leer Tarjeta",
    "FaceTec_idscan_nfc_status_finished_with_success_message": "NFC Escaneado<br/>Exitosamente",
    // ===== MENSAJES ADICIONALES DE REVIEW =====
    "FaceTec_result_idscan_additional_review_tag_message": "Revisión<br/>Adicional",
    // ===== MENSAJES DE SESIÓN ABORT =====
    "FaceTec_result_session_abort_message": "Sesión<br/>Cancelada",
    // ===== PANTALLA DE ORIENTACIÓN =====
    "FaceTec_orientation_message": "Por Favor Gire<br/>su Dispositivo",
    // ===== MENSAJES DE CAPTURA DE ID =====
    "FaceTec_idscan_capture_tap_to_focus_message": "Toque para Enfocar",
    // ===== MENSAJES DE PROBLEMA CON CÁMARA (Desktop Browser) =====
    "FaceTec_camera_feed_issue_header_mobile": "Problema con la Cámara",
    "FaceTec_camera_feed_issue_subheader_message_mobile": "No se puede acceder a la cámara del dispositivo.",
    "FaceTec_camera_feed_issue_table_header_1": "Posible Causa",
    "FaceTec_camera_feed_issue_table_header_2": "Solución",
    "FaceTec_camera_feed_issue_action": "Intentar Nuevamente",
    "FaceTec_camera_feed_issue_action_firefox_permissions_error": "OK",
    // ===== IMAGEN SUBIDA =====
    "FaceTec_result_idscan_image_uploaded": "Imagen de Documento<br/>Subida",
};
/**
 * Traducciones para el OCR de documentos (campos del formulario)
 */
export var FACETEC_OCR_SPANISH = {
    "groups": [
        {
            "groupFriendlyName": "Su Información",
            "fields": [
                {
                    "fieldKey": "profession",
                    "fieldFriendlyName": "Profesión",
                    "uiFieldDescriptionText": "Profesión"
                },
                {
                    "fieldKey": "lastName",
                    "fieldFriendlyName": "Apellido",
                    "uiFieldDescriptionText": "Apellido"
                },
                {
                    "fieldKey": "firstName",
                    "fieldFriendlyName": "Nombre",
                    "uiFieldDescriptionText": "Nombre"
                },
                {
                    "fieldKey": "fullName",
                    "fieldFriendlyName": "Nombre Completo",
                    "uiFieldDescriptionText": "Nombre Completo"
                },
                {
                    "fieldKey": "dateOfBirth",
                    "fieldFriendlyName": "Fecha de Nacimiento",
                    "uiFieldDescriptionText": "Fecha de Nacimiento"
                },
                {
                    "fieldKey": "nationality",
                    "fieldFriendlyName": "Nacionalidad",
                    "uiFieldDescriptionText": "Nacionalidad"
                },
                {
                    "fieldKey": "sex",
                    "fieldFriendlyName": "Sexo",
                    "uiFieldDescriptionText": "Sexo"
                }
            ],
            "groupKey": "userInfo"
        },
        {
            "groupFriendlyName": "Su Dirección",
            "fields": [
                {
                    "fieldKey": "address1",
                    "fieldFriendlyName": "Dirección Línea 1",
                    "uiFieldDescriptionText": "Dirección Línea 1"
                },
                {
                    "fieldKey": "city",
                    "fieldFriendlyName": "Ciudad",
                    "uiFieldDescriptionText": "Ciudad"
                },
                {
                    "fieldKey": "commune",
                    "fieldFriendlyName": "Comuna",
                    "uiFieldDescriptionText": "Comuna"
                },
                {
                    "fieldKey": "region",
                    "fieldFriendlyName": "Región",
                    "uiFieldDescriptionText": "Región"
                },
                {
                    "fieldKey": "country",
                    "fieldFriendlyName": "País",
                    "uiFieldDescriptionText": "País"
                }
            ],
            "groupKey": "addressInfo"
        },
        {
            "groupFriendlyName": "Detalles del Documento",
            "fields": [
                {
                    "fieldKey": "idNumber",
                    "fieldFriendlyName": "RUT / Número de Documento",
                    "uiFieldDescriptionText": "RUT / Número de Documento"
                },
                {
                    "fieldKey": "dateOfIssue",
                    "fieldFriendlyName": "Fecha de Emisión",
                    "uiFieldDescriptionText": "Fecha de Emisión"
                },
                {
                    "fieldKey": "dateOfExpiration",
                    "fieldFriendlyName": "Fecha de Vencimiento",
                    "uiFieldDescriptionText": "Fecha de Vencimiento"
                },
                {
                    "fieldKey": "issuingAuthority",
                    "fieldFriendlyName": "Autoridad Emisora",
                    "uiFieldDescriptionText": "Autoridad Emisora"
                }
            ],
            "groupKey": "idInfo"
        }
    ]
};
